import { Box } from '@mui/material'
import { useVoiceEventMarkers } from '@/map'

import { NoNotifications } from './NoNotifications'
import { OrderStepNotificationItem } from './OrderStepNotificationItem'

interface Props {
  notifications: workwave.DeepReadonly<uui.domain.client.rm.OrderStepNotification[]>
  showModal: (data: uui.domain.client.rm.OrderStepNotification) => void
}

export function OrderStepNotificationList(props: Props) {
  const { showModal, notifications } = props
  useVoiceEventMarkers()

  if (notifications.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 'calc(100vh - 300px)',
          width: '100%',
        }}
      >
        <NoNotifications />
      </Box>
    )
  }

  return (
    <>
      {notifications.map((item, key) => (
        <OrderStepNotificationItem item={item} key={key} showModal={showModal} />
      ))}
    </>
  )
}
